import React from "react";
import Header from "../Components/nav";
import Footer from "../Components/footer";

import Terms from "../Components/terms";
import Bottomfooter from "../Components/bottomfooter";

const TermsRoute = () => {
  return (
    <div>
      <Header />
      <Terms />
      <Footer />
      {/* <Bottomfooter /> */}
    </div>
  );
};

export default TermsRoute;
